// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N5ef","name":"styles_name__3A611","phone":"styles_phone__mzq8f"};